<script>
import { isEmpty } from 'lodash-es'
import { mapState } from 'vuex'

import RouterLinkEx from '../components/common/RouterLinkEx'
import URLSearchParams from 'url-search-params'
import { namespace } from '../store/modules/session-store'
import { namespace as commonNamespace } from '../store/modules/common-store'
import { parseServiceName } from '../common/service-name-utils'
import envs from '../common/envs';

const japanPattern = /^\/(jp\/.*|jp)$/
const japanPattern2 = /%2Fjp/
const categoryAlias = Object.freeze({
  Compute: '01',
  Network: '02',
  Storage: '03',
  Game: '04',
  Notification: '05',
  Database: '06',
  'Content Delivery': '07',
  Security: '08',
  'Mobile Service': '09',
  'Dev Tools': '10',
  Analytics: '11',
  'Application Service': '12',
  Search: '13',
  Management: '14',
  'Dooray!': '15',
  'Workplace | ERP': '16',
  'Contact Center': '17',
  Bill: '18',
  IDC: '19',
  ETC: '20',
  CloudTrail: '21',
  'Market Place': '22',
  'Workplace | Groupware': '23',
  Container: '24',
  'PaaS-TA': '50'
})
const categoryAliasGov = Object.freeze({
  Compute: '01',
  Network: '02',
  Storage: '03',
  Game: '04',
  Notification: '05',
  Database: '06',
  'Content Delivery': '07',
  Security: '08',
  'Mobile Service': '09',
  'Dev Tools': '28',
  Analytics: '27',
  'Application Service': '25',
  Search: '26',
  Management: '30',
  'Dooray!': '15',
  'Workplace | ERP': '16',
  'Contact Center': '29',
  Bill: '18',
  IDC: '19',
  ETC: '20',
  CloudTrail: '21',
  'Market Place': '22',
  Container: '24',
  'PaaS-TA': '23'
})
const categoryAliasMap = {
  'public': categoryAlias,
  'gov': categoryAliasGov
}

export default {
  components: { RouterLinkEx },
  computed: {
    ...mapState(commonNamespace, ['isMobile']),
    ...mapState(namespace, ['userCountry', 'session']),
    canUseRoute() {
      return mode == 'homepage'
    },
    isLoggedInUserFromKr() {
      const existUserCountry = !!this.userCountry
      const existSession = !!this.session.uuid
      return existSession && existUserCountry ? this.userCountry.code === 'KR' || !!!this.userCountry.code : false
    },
    isJp() {
      const existUserCountry = !!this.userCountry
      const existSession = !!this.session.uuid
      const isNotHomepageMode = !(mode === 'homepage' || mode === 'gnb')
      if ((existSession || isNotHomepageMode) && existUserCountry) {
        return this.userCountry.code === 'JP'
      }
      const routeHref = window.location.href
      if (routeHref.includes('id.toast') || routeHref.includes('id.nhncloud')) return japanPattern2.test(routeHref)

      const routePath = window.location.pathname
      return japanPattern.test(routePath)
    },
    countryCode() {
      return this.isJp ? 'JP' : 'KR'
    },
    countryPath() {
      return this.isJp ? `/jp` : '/kr'
    },
    supportInquiryBaseUrl() {
      return `${this.countryPath}/support/inquiry`
    },
    currencyByCountry() {
      return this.$t(`common.${this.countryCode.toLowerCase()}.currency`)
    },
    currencyByCountryPerMonth() {
      return `${this.currencyByCountry}/${this.$t('common.month')}`
    },
    isMobileConsoleApp() {
      const userAgent = navigator.userAgent
      const mobileAppUserAgentStartWith = 'Console/'
      return userAgent.indexOf(mobileAppUserAgentStartWith) > -1
    }
  },
  methods: {
    getDomain(key) {
      return domain[key]
    },
    getInquiryUrlAlias(category) {
      const alias = categoryAliasMap[target][category]
      return alias === undefined ? '20' : alias
    },
    getToastIdUrl(functionName) {
      let nextUrlParam = new URLSearchParams(location.search).get('nextUrl')
      let nextUrl = isEmpty(nextUrlParam) ? encodeURIComponent(location.href) : encodeURIComponent(nextUrlParam)
      return `${this.getDomain('toastId')}/${functionName}/?nextUrl=${nextUrl}`
    },
    getTrimmedBadges(badges) {
      return badges.map(badge => badge.trim())
    },
    isSameService(left, right) {
      return this.parseServiceName(left) == this.parseServiceName(right)
    },
    parseServiceName(serviceName) {
      return parseServiceName(serviceName)
    },
    exist(list) {
      return isEmpty(list) == false
    },
    isEmpty(list) {
      return isEmpty(list)
    },
    openPopup(popupUrl, width, height, targetName) {
      let top = (screen.availHeight - height) / 2
      let left = screen.availWidth + width

      let option = `height=${height},width=${width},menubar=no,toolbar=no,location=no,resizable=no,status=no,scrollbars=yes,top=${top},left=${left}`
      return window.open(popupUrl, targetName, option)
    },
    // todo: 2018.10.04 foreach 개선해야 함
    replacei18(message, arrays) {
      return message.replace('{0}', arrays[0])
    },
    swapRowColWithMaxCol(array, max_col) {
      if (!Array.isArray(array) || array.length === 0) return array

      const array_max_col = array.length
      const array_max_row = array[0].length
      const flatList = []

      for (let i = 0; i < array_max_row; i++) {
        for (let j = 0; j < array_max_col; j++) {
          if (!isEmpty(array[j][i])) flatList.push(array[j][i])
        }
      }

      const covertedArray = Array.from(Array(max_col), () => new Array(2))
      flatList.forEach((item, index) => {
        const col = index % max_col
        const row = Math.floor(index / max_col)
        covertedArray[row][col] = item
      })

      return covertedArray
    },
    pricingServiceGroup(services) {
      const categoryCol5 = services
      const categoryList = []
      const col = categoryCol5.length
      const max_row = categoryCol5[0].length
      for (let i = 0; i < max_row; i++) {
        for (let j = 0; j < col; j++) {
          if (!isEmpty(categoryCol5[j][i])) {
            const category = categoryCol5[j][i]
            const serviceList = envs.common.service.filter.enabled?
              category.services.filter(service => {
                  return !!service.price
                })
              : category.services
            if (!isEmpty(serviceList)) categoryList.push(category)
          }
        }
      }
      const categoryCol4 = Array.from(Array(4), () => new Array(2))
      categoryList.forEach((service, index) => {
        const col = index % 4
        const row = Math.floor(index / 4)
        categoryCol4[col][row] = service
      })
      return categoryCol4
    },
    showGnbBadges(serviceMenuClass) {
      return serviceMenuClass !== 'is_' && !isEmpty(serviceMenuClass)
    }
  }
}
</script>
